import { useState } from "react";
import axios from "./axios";
import { toast } from "sonner";
import { useLocation, useNavigate } from "react-router-dom";

export const useForgotPassword = () => {
  const navigate = useNavigate();
  const [emailAddress, setEmailAddress] = useState("");
  const [fPassword, setFPassword] = useState("");
  const [confirmFPassword, setConfirmFPassword] = useState("");
  const [pending, setPending] = useState("");
  const search = useLocation();

  const handleForgotPassword = async () => {
    try {
      setPending(true);
      const response = await axios.post(
        "/audiences/auth/forgot-password",
        JSON.stringify({
          email_or_phone: emailAddress,
        })
      );

      if (response.status === 200) {
        setPending(false);
        toast.success(response.data.message);
        navigate(
          `/verify-otp${
            search?.search ? `${search?.search}&` : "?"
          }mobile=${encodeURIComponent(emailAddress)}&type=fp`
        );
      }
    } catch (err) {
      setPending(false);
      if (!err?.response) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 404) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 422) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Validation Failed, please try again");
      }
    }
  };

  const handleChangePassword = async () => {
    try {
      setPending(true);
      const response = await axios.post(
        "/audiences/auth/change-password",
        JSON.stringify({
          email_or_phone: emailAddress,
          password: fPassword,
          password_confirmation: confirmFPassword,
        })
      );

      if (response.status === 200) {
        setPending(false);
        toast.success(response.data.message);
        navigate(`/${search?.search ? `${search?.search}` : ""}`);
      }
    } catch (err) {
      setPending(false);
      if (!err?.response) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 404) {
        toast.error(err.response.data.message);
      } else if (err.response?.status === 422) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Validation Failed, please try again");
      }
    }
  };

  return {
    handleForgotPassword,
    handleChangePassword,
    pending,
    setEmailAddress,
    emailAddress,
    setFPassword,
    setConfirmFPassword,
  };
};
